import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VendorProjectNotice } from '../models/vendor-project-notice';

// NK-391: the first-visit Project Notice popup in the vendor portal.
@Injectable({
  providedIn: 'root'
})
export class VendorProjectNoticeService {

  baseUrl = environment.apiEndpoint + '/partner';

  // NK-391: projects whose notice has already been resolved (shown, or ruled out) in this browser
  // session. The guard has to live here and not in ProjectDetailsComponent: opening a project goes
  // to /projects/{id}, and GetProjectLayout then redirects to /projects/{id}/{section} - a
  // different route config, so Angular destroys and re-creates the component instead of reusing
  // it. A component-level flag resets on that re-creation and the notice pops a second time, on
  // top of the first (BsModalService is root-scoped, so the first modal outlives its component).
  // Nothing needs to clear this on logout - AuthService.logOut() reloads the page.
  private resolvedProjectIds = new Set<string>();

  constructor(private http: HttpClient) { }

  noticeResolved(projectId: string): boolean {
    return this.resolvedProjectIds.has(projectId);
  }

  markNoticeResolved(projectId: string): void {
    this.resolvedProjectIds.add(projectId);
  }

  // Used when the check itself failed, so the next visit to the project tries again.
  clearNoticeResolved(projectId: string): void {
    this.resolvedProjectIds.delete(projectId);
  }

  // Whether the logged-in vendor contact still needs the notice on this project, plus the copy.
  getVendorProjectNotice(projectId: string): Observable<VendorProjectNotice> {
    return this.http.get<VendorProjectNotice>(`${this.baseUrl}/vendorprojectnotice/${projectId}`);
  }

  // Records the acknowledgement so the popup does not return for this contact on this project.
  acknowledgeVendorProjectNotice(projectId: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/vendorprojectnotice/${projectId}`, {});
  }
}
